import { PaymentMethodI } from '..';

export const resolveTxRef = (
  selectedPaymentMethod: PaymentMethodI | null,
  paymentMethod: PaymentMethodI,
  txRef: string | undefined
) => {
  return selectedPaymentMethod === paymentMethod && txRef ? txRef : undefined;
};
